export default "__VITE_ASSET__DVy44JEB__"